<template>
  <section class="page-section">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h1 class="section-title text-center">
            {{ $t('label.title.whoAreEligible') }}
          </h1>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-sm-12 col-md-4">
              <div class="eligibility">
                <div class="eligibility-icon">
                  <img
                    src="../../../assets/images/location.png"
                    alt="location.png"
                  >
                </div>
                <div class="eligibility-description">
                  <div class="content-header">
                    {{ $t('label.location').toUpperCase() }}
                  </div>
                  <div class="content-body">
                    {{ $t('label.body.location') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-4">
              <div class="eligibility">
                <div class="eligibility-icon">
                  <div
                    class="eligibility-icon-badge"
                    style="position: relative"
                  >
                    <img
                      src="../../../assets/images/age.png"
                      alt="age.png"
                    >
                    <div class="eligibility-badge">
                      <i class="fa fa-plus" />
                    </div>
                  </div>
                </div>
                <div class="eligibility-description">
                  <div class="content-header">
                    {{ $t('label.age').toUpperCase() }}
                  </div>
                  <div class="content-body">
                    {{ $t('label.body.age') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-4">
              <div class="eligibility">
                <div class="eligibility-icon">
                  <img
                    src="../../../assets/images/occupation.png"
                    alt="occupation.png"
                  >
                </div>
                <div class="eligibility-description">
                  <div class="content-header">
                    {{ $t('label.occupation').toUpperCase() }}
                  </div>
                  <div class="content-body">
                    {{ $t('label.body.occupation') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeEligible'
}
</script>

<style scoped>
.eligibility-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 15px;
}

.eligibility-icon-badge {
  width: 65px;
  height: 65px;
}

.eligibility-icon-badge > img,
.eligibility-icon > img {
  height: 100%;
}

.eligibility {
  /*display: flex;*/
  margin-bottom: 20px;
  /*align-items: center;*/
  /*justify-content: center;*/
  text-align: center;
}

.eligibility-description {
    margin-left: 10px;
  }

  .eligibility-badge {
    position: absolute;
    top: -2px;
    right: -20px;
    background-color: var(--primary);
    color: white;
    border-radius: 50%;
    height: 29px;
    width: 29px;
    text-align: center;
    padding-top: 3px;
  }

  @media screen and (max-width: 991px) {
    .eligibility-icon-badge,
    .eligibility-icon {
      height: 60px;
      width: 60px;
      margin: 15px auto;
    }
  }

  @media screen and (max-width: 767px) {
    .eligibility-icon-badge,
    .eligibility-icon {
      height: 50px;
      width: 50px;
      margin: 20px auto;
    }
  }
</style>
